import * as React from "react";
import { useLoaderData, useNavigate } from 'react-router-dom';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Header from "../components/Header";
import { listAnimals } from "../models/animals";
import { listAssessments } from "../models/assessments";
import { listChanges } from "../models/changes";
import { listUsers } from "../models/users";

import {useMessage} from "../context/MessageProvider";


import {useForm, FormProvider} from 'react-hook-form';
import Form from '../components/form/Form';
import FormTextField from '../components/form/FormTextField';
import FormButton from '../components/form/FormButton';
import FormDropDown from '../components/form/FormDropDown';
import FormDropDownFilter from '../components/form/FormDropDownFilter';

import { date } from "../utils/datetime";
import { name as animalName } from "../utils/animal";
import { name as speciesName } from "../utils/species";

import { fetchAssessmentExportDataByAnimalId } from "../models/assessments";
import { zip } from "../utils/zip";
import { downloadBlob } from "../utils/download";

import { assessmentCsvList } from "../utils/assessments";

export async function loader() {
  const animals = await listAnimals();
  const users = await listUsers();
  const assessments = await listAssessments();
  const changes = await listChanges();
  return { animals, assessments, changes, users};
}


export default function ReportingPage({ title = "Reporting", ...props }) {

  const { animals, assessments, users } = useLoaderData();
  const navigate = useNavigate();
  const {setSuccess, setError} = useMessage();

  //const {inProgressObservations, current, clearObservations, startClipboardMode} = useSectionB();

  const [working,setWorking] = React.useState(false);

  const onSubmit = async(inputData) => {
    try {
      console.log("onSubmit data: ", inputData);
      setWorking(true);


      if (inputData?.output_type === "report") {
        const previousCount = inputData.previous_assessments_to_include || 4;
        navigate(`/assessments/${inputData.assessment_id}/report/${previousCount}`);
      } else if (inputData?.output_type === "csv") {

        console.log("csv export");
        const data = await fetchAssessmentExportDataByAnimalId(inputData.animal_id, inputData.previous_assessments_to_include);
        console.log("csv data", data);
        const fileData = assessmentCsvList({assessments: data, animals, users});
        const zipData = zip(fileData);
        const zipBlob = new Blob([zipData], {type: "application/zip"});
        downloadBlob({blob: zipBlob, filename: "assessment_data.zip"});
      }

      setSuccess("Report Done");
    } catch (error) {
      console.error(error);
      setError(error.message);
    } finally {
      setWorking(false);
    }
  }


  const completedAssessments = assessments.filter((cur) => {
    return cur.submitted_on !== null;
  });

  completedAssessments.sort((a, b) => {
    if (a.submitted_on.isBefore(b.submitted_on)) {
      return 1
    } else if (a.submitted_on.isAfter(b.submitted_on)) {
      return -1
    } else {
      return 0;
    }
  });

  console.log("completed assessment count", completedAssessments.length);
  const [animalAssessments, setAnimalAssessments] = React.useState([]);

  const onChange = async(inputData) => {
    console.log("onChange ", inputData);

    const tempList = completedAssessments.filter((cur) => {
      return cur.animal_id === inputData.animal_id;
    }).map((cur)=>{
      console.log(cur);
      return {
        value: cur.id,
        label: "Assessment Started " + date(cur.started_on) + ", Submitted " + date(cur.submitted_on),
      };
    })
    setAnimalAssessments(tempList);

  }



  const animalList = animals.map((cur) => {
    return {
      value: cur.id,
      label: animalName(cur),
    };
  });

    const speciesFilter = animals.reduce((acc, cur) => {
        if (acc.includes(cur.species) === false) acc.push(cur.species);
        return acc
    }, []).map((cur) => {
        return { value: cur, label: speciesName(cur) };
    });


  const defaultValues = {
    animal_id: '',
    assessment_id: '',
    previous_assessments_to_include: 4,
    output_type: "report",
  }

  const methods = useForm({ defaultValues });

  // how many into the past to get?
  // select which assessments to include?
  // report output type?

  return (
  <Container component="main" maxWidth="md">
    <Header label={title} />

      <FormProvider {...methods}>
      <Form onSubmit={methods.handleSubmit(onSubmit)} onChange={onChange}>
            <Grid container spacing={2}>
                <Grid xs={12}>
                    <FormDropDownFilter name="animal_id" label="Animal" list={animalList} enableTextFilter={true} enableSelectFilter={true}  selectFilterList={speciesFilter} required/>
                </Grid>

                <Grid xs={12}>
                    <FormDropDown name="assessment_id" label="Assessments" list={animalAssessments} required/>
                </Grid>

                <Grid xs={12}>
                  <FormTextField name="previous_assessments_to_include" label="Previous Assessments To Include" rules={{ pattern: {
                      value: /^[0-9]+$/,
                      message: "Only whole numbers are allowed",
                    }
                  }} required/>
                </Grid>

                <Grid xs={12}>
                    <FormDropDown name="output_type" label="Output Type" list={[{value: "report", label: "Report"}, {value: "csv", label: "CSV"}]} required/>
                </Grid>

                <Grid xs={12}>
                    <FormButton working={working}>Submit</FormButton>
                </Grid>
            </Grid>
	      </Form>
    </FormProvider>
  </Container>
  );
}
